import React from 'react';
import { Box } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OutdoorBackground from '../components/OutdoorBackground';
import SkipLink from '../components/SkipLink';

interface MainLayoutProps {
  children: React.ReactNode;
  backgroundVariant?: 'light' | 'dark';
  backgroundDensity?: 'low' | 'medium' | 'high';
}

const MainLayout: React.FC<MainLayoutProps> = ({ 
  children, 
  backgroundVariant = 'light', 
  backgroundDensity = 'low' 
}) => {
  return (
    <>
      <SkipLink />
      <Box 
        component="div"
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          minHeight: '100vh',
          height: '100%',
          backgroundColor: 'background.default',
        }}
      >
        <Navbar />
        <OutdoorBackground variant={backgroundVariant} density={backgroundDensity}>
          <Box 
            component="main"
            id="main-content"
            role="main"
            tabIndex={-1}
            sx={{ 
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              pt: 2, 
              pb: 4,
              zIndex: 1,
              '&:focus': {
                outline: 'none'
              }
            }}
          >
            {children}
          </Box>
        </OutdoorBackground>
        <Footer />
      </Box>
    </>
  );
};

export default MainLayout; 